// extracted by mini-css-extract-plugin
export var searchHeader = "_72-0";
export var searchHeaderDark = "_72-1";